// Midi drum notes that correspond to the 8-supported drum types in Music Lab pattern blocks.
export const musiclabMidiDrumNotes = {
  kick: 36,
  snare: 38,
  hiHatClosed: 42,
  hiHatOpen: 46,
  tomMid: 47,
  tomHigh: 50,
  ride: 51,
  cymbal: 49,
};

// Midi drum notes that correspond to General Midi/General Standard drum sounds.
const generalMidiDrumNotes = {
  filterSnap: 27,
  slapNoise: 28,
  scratchPush: 29,
  scratchPull: 30,
  drumSticks: 31,
  squareClick: 32,
  metronomeClick: 33,
  metronomeBell: 34,
  acousticBassDrum: 35,
  bassDrum1: 36,
  sideStick: 37,
  acousticSnare: 38,
  handClap: 39,
  electricSnare: 40,
  lowFloorTom: 41,
  closedHiHat: 42,
  highFloorTom: 43,
  pedalHiHat: 44,
  lowTom: 45,
  openHiHat: 46,
  lowMidTom: 47,
  hiMidTom: 48,
  crashCymbal1: 49,
  highTom: 50,
  rideCymbal1: 51,
  chineseCymbal: 52,
  rideBell: 53,
  tambourine: 54,
  splashCymbal: 55,
  cowbell: 56,
  crashCymbal2: 57,
  vibraslap: 58,
  rideCymbal2: 59,
  hiBongo: 60,
  lowBongo: 61,
  muteHiConga: 62,
  openHiConga: 63,
  lowConga: 64,
  highTimbale: 65,
  lowTimbale: 66,
  highAgogo: 67,
  lowAgogo: 68,
  cabasa: 69,
  maracas: 70,
  shortWhistle: 71,
  longWhistle: 72,
  shortGuiro: 73,
  longGuiro: 74,
  claves: 75,
  hiWoodBlock: 76,
  lowWoodBlock: 77,
  muteCuica: 78,
  openCuica: 79,
  muteTriangle: 80,
  openTriangle: 81,
  jingleBell: 83,
  belltree: 84,
  castanets: 85,
  muteSurdo: 86,
  openSurdo: 87,
};

// A mapping of general midi sounds to our supported drum sounds.
export const reverseMidiMapping = new Map([
  [generalMidiDrumNotes.acousticBassDrum, musiclabMidiDrumNotes.kick],
  [generalMidiDrumNotes.bassDrum1, musiclabMidiDrumNotes.kick],
  [generalMidiDrumNotes.filterSnap, musiclabMidiDrumNotes.snare],
  [generalMidiDrumNotes.slapNoise, musiclabMidiDrumNotes.snare],
  [generalMidiDrumNotes.drumSticks, musiclabMidiDrumNotes.snare],
  [generalMidiDrumNotes.squareClick, musiclabMidiDrumNotes.snare],
  [generalMidiDrumNotes.metronomeClick, musiclabMidiDrumNotes.snare],
  [generalMidiDrumNotes.metronomeBell, musiclabMidiDrumNotes.snare],
  [generalMidiDrumNotes.sideStick, musiclabMidiDrumNotes.snare],
  [generalMidiDrumNotes.acousticSnare, musiclabMidiDrumNotes.snare],
  [generalMidiDrumNotes.handClap, musiclabMidiDrumNotes.snare],
  [generalMidiDrumNotes.electricSnare, musiclabMidiDrumNotes.snare],
  [generalMidiDrumNotes.cowbell, musiclabMidiDrumNotes.snare],
  [generalMidiDrumNotes.highTimbale, musiclabMidiDrumNotes.snare],
  [generalMidiDrumNotes.lowTimbale, musiclabMidiDrumNotes.snare],
  [generalMidiDrumNotes.claves, musiclabMidiDrumNotes.snare],
  [generalMidiDrumNotes.castanets, musiclabMidiDrumNotes.snare],
  [generalMidiDrumNotes.closedHiHat, musiclabMidiDrumNotes.hiHatClosed],
  [generalMidiDrumNotes.pedalHiHat, musiclabMidiDrumNotes.hiHatClosed],
  [generalMidiDrumNotes.tambourine, musiclabMidiDrumNotes.hiHatClosed],
  [generalMidiDrumNotes.lowAgogo, musiclabMidiDrumNotes.hiHatClosed],
  [generalMidiDrumNotes.cabasa, musiclabMidiDrumNotes.hiHatClosed],
  [generalMidiDrumNotes.maracas, musiclabMidiDrumNotes.hiHatClosed],
  [generalMidiDrumNotes.shortWhistle, musiclabMidiDrumNotes.hiHatClosed],
  [generalMidiDrumNotes.shortGuiro, musiclabMidiDrumNotes.hiHatClosed],
  [generalMidiDrumNotes.muteCuica, musiclabMidiDrumNotes.hiHatClosed],
  [generalMidiDrumNotes.muteTriangle, musiclabMidiDrumNotes.hiHatClosed],
  [generalMidiDrumNotes.openHiHat, musiclabMidiDrumNotes.hiHatOpen],
  [generalMidiDrumNotes.highAgogo, musiclabMidiDrumNotes.hiHatOpen],
  [generalMidiDrumNotes.longWhistle, musiclabMidiDrumNotes.hiHatOpen],
  [generalMidiDrumNotes.longGuiro, musiclabMidiDrumNotes.hiHatOpen],
  [generalMidiDrumNotes.openCuica, musiclabMidiDrumNotes.hiHatOpen],
  [generalMidiDrumNotes.openTriangle, musiclabMidiDrumNotes.hiHatOpen],
  [generalMidiDrumNotes.scratchPush, musiclabMidiDrumNotes.tomMid],
  [generalMidiDrumNotes.lowFloorTom, musiclabMidiDrumNotes.tomMid],
  [generalMidiDrumNotes.lowTom, musiclabMidiDrumNotes.tomMid],
  [generalMidiDrumNotes.lowMidTom, musiclabMidiDrumNotes.tomMid],
  [generalMidiDrumNotes.hiMidTom, musiclabMidiDrumNotes.tomMid],
  [generalMidiDrumNotes.lowBongo, musiclabMidiDrumNotes.tomMid],
  [generalMidiDrumNotes.lowConga, musiclabMidiDrumNotes.tomMid],
  [generalMidiDrumNotes.lowWoodBlock, musiclabMidiDrumNotes.tomMid],
  [generalMidiDrumNotes.belltree, musiclabMidiDrumNotes.tomMid],
  [generalMidiDrumNotes.muteSurdo, musiclabMidiDrumNotes.tomMid],
  [generalMidiDrumNotes.openSurdo, musiclabMidiDrumNotes.tomMid],
  [generalMidiDrumNotes.scratchPull, musiclabMidiDrumNotes.tomHigh],
  [generalMidiDrumNotes.highFloorTom, musiclabMidiDrumNotes.tomHigh],
  [generalMidiDrumNotes.highTom, musiclabMidiDrumNotes.tomHigh],
  [generalMidiDrumNotes.hiBongo, musiclabMidiDrumNotes.tomHigh],
  [generalMidiDrumNotes.muteHiConga, musiclabMidiDrumNotes.tomHigh],
  [generalMidiDrumNotes.openHiConga, musiclabMidiDrumNotes.tomHigh],
  [generalMidiDrumNotes.hiWoodBlock, musiclabMidiDrumNotes.tomHigh],
  [generalMidiDrumNotes.jingleBell, musiclabMidiDrumNotes.tomHigh],
  [generalMidiDrumNotes.rideCymbal1, musiclabMidiDrumNotes.ride],
  [generalMidiDrumNotes.chineseCymbal, musiclabMidiDrumNotes.ride],
  [generalMidiDrumNotes.rideBell, musiclabMidiDrumNotes.ride],
  [generalMidiDrumNotes.rideCymbal2, musiclabMidiDrumNotes.ride],
  [generalMidiDrumNotes.crashCymbal1, musiclabMidiDrumNotes.cymbal],
  [generalMidiDrumNotes.splashCymbal, musiclabMidiDrumNotes.cymbal],
  [generalMidiDrumNotes.crashCymbal2, musiclabMidiDrumNotes.cymbal],
  [generalMidiDrumNotes.vibraslap, musiclabMidiDrumNotes.cymbal],
]);
